import { Outlet, useLocation } from 'react-router-dom';
import { TabBar } from './TabBar';

/**
 * Mobile-first responsive shell. На широком экране ограничиваем контент 480px.
 * Табы скрываются на drill-down sub-pages кампании, на странице треда (свой composer)
 * и на форме создания кампании (свой sticky-footer).
 */
export function AppShell(): JSX.Element {
  const loc = useLocation();
  const isHidden =
    /^\/campaigns\/(new|\d+\/(chats|accounts|team|dialogs|prompts|launch|logs|history|reports|inbox(\/.+)?))$/.test(
      loc.pathname,
    ) || /^\/accounts\/\d+(\/(dialogs|logs))?$/.test(loc.pathname);
  const showTabs = !isHidden;

  return (
    <div className="relative mx-auto min-h-screen w-full max-w-md bg-transparent">
      <main
        key={loc.pathname}
        className="page-enter px-4 pb-28 pt-[max(20px,calc(var(--safe-top)+8px))]"
      >
        <Outlet />
      </main>
      {showTabs && <TabBar />}
    </div>
  );
}
